export default __webpack_public_path__ + "static/media/ddn-mars.46d994da.gif";